<template>
  <div class="mission-honeycomb" :class="{ 'is-completed': mission.hasCompleted }">
    <ul class="mission-honeycomb__list">
      <li
        v-for="(condition, index) in mission.achievementCondition"
        :key="index"
        class="mission-honeycomb__item"
      >
        <mission-hexagon-circuit-parts :mission="mission" :condition="condition" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonCircuitParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonCircuitParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'

export default defineComponent({
  name: 'MissionHoneyCombCircuitParts',
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
  },
  components: {
    MissionHexagonCircuitParts,
  },
  setup() {
    return {}
  },
})
</script>

<style scoped lang="scss">
.mission-honeycomb {
  &.is-completed {
    .mission-honeycomb__item {
      width: 62px;
      margin-left: -28px;

      &:first-child {
        margin-left: 0;
      }

      &:nth-child(even) {
        margin-top: 56px;
      }
    }
  }

  &__list {
    display: flex;
  }

  &__item {
    flex-shrink: 0;
    width: 84px;
    margin-left: -40px;

    &:first-child {
      margin-left: 0;
    }

    &:nth-child(even) {
      margin-top: 75px;
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    .mission-honeycomb__item {
      margin-left: -23px;

      &:first-child {
        margin-left: 0;
      }

      &:nth-child(even) {
        margin-top: 104px;
      }
    }

    &.is-completed {
      .mission-honeycomb__item {
        width: 115px;
        margin-left: -53px;

        &:first-child {
          margin-left: 0;
        }

        &:nth-child(even) {
          margin-top: 104px;
        }
      }
    }
  }
}
</style>
